/* ================================================== */
/* SHARE > Facebook
/* ================================================== */

$(document).ready(function() {
	var $el = $('.share-facebook');
	if ($el.length) {
		$el.each(function(index, element) {
			var appId = $(element).data('app-id');
			$.ajaxSetup({ cache: true });
			$.getScript('//connect.facebook.net/en_US/sdk.js', function() {
				FB.init({
					appId: appId,
					version: 'v5.0'
				});

				$(element).click(function() {
					var url = $(this).data('url');
					FB.ui({
						method: 'share',
						href: url
					});
				});
			});
		});
	}
});